import { FC, Fragment } from "react";

import {
  UNIT_SOURCE_ID,
  useMainContextValues,
} from "../../../../../../model";
import { SimpleLessonItem } from "../simple-lesson-item/SimpleLessonItem";
import { UnitItem } from "../unit-item/UnitItem";

type Props = {
  currentList: string[],
  isSubList?: boolean,
  closeCourseContentAction?: () => void,
};

export const ListLesson: FC<Props> = ({
  currentList,
  isSubList = false,
  closeCourseContentAction,
}) => {
  const {
    library,
    unitsChildren,
  } = useMainContextValues();

  return (
    <ul className="edtech-course-completion">
      {
        currentList.map((nodeId) => {
          const lesson = library?.[ nodeId ];

          if (!lesson) return <Fragment key={nodeId}></Fragment>;

          const {
            materialType,
            title,
            isFinished,
            hideCard,
            elementSource,
            isParentAvailable,
          } = lesson;

          const isPassed = isFinished === true;
          const isUnit = elementSource === UNIT_SOURCE_ID;
          const isLessonDisabled = hideCard || !isParentAvailable;

          if (!isUnit) {
            return (
              <SimpleLessonItem
                key={nodeId}
                closeCourseContentAction={closeCourseContentAction}
                isDisabledLesson={isLessonDisabled}
                isPassed={isPassed}
                isSubList={isSubList}
                materialType={materialType}
                title={title}
                nodeId={nodeId}
              />
            );
          }

          const childrenList = unitsChildren?.[ nodeId ] || [];

          if (!childrenList.length) return <Fragment key={nodeId}></Fragment>;

          return (
            <UnitItem
              key={nodeId}
              childrenList={childrenList}
              closeCourseContentAction={closeCourseContentAction}
              isDisabledLesson={hideCard}
              isPassed={isPassed}
              isSubList={isSubList}
              title={title}
              nodeId={nodeId}
            />
          );
        })
      }
    </ul>
  );
};
